<div class="container-fluid mt-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header bg-primary text-white">
          <h4 class="mb-0">
            <i class="fas fa-folder-open mr-2"></i>
            Biblioteca de Arquivos - Insumos
          </h4>
        </div>

        <div class="card-body">
          <!-- Filtros -->
          <form [formGroup]="filtrosForm" class="mb-4">
            <div class="row">
              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Nome do Arquivo</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="fileName"
                    placeholder="Buscar por nome..."
                  />
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Segmento</mat-label>
                  <mat-select formControlName="segment">
                    <mat-option value="TODOS">Todos</mat-option>
                    <mat-option *ngFor="let seg of segmentos" [value]="seg">
                      {{ seg }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Status</mat-label>
                  <mat-select formControlName="status">
                    <mat-option value="TODOS">Todos</mat-option>
                    <mat-option *ngFor="let st of status" [value]="st">
                      {{ getStatusLabel(st) }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Competência</mat-label>
                  <mat-select formControlName="competence">
                    <mat-option value="TODOS">Todas</mat-option>
                    <mat-option *ngFor="let comp of competencias" [value]="comp">
                      {{ comp }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Responsável pelo Upload</mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="uploaderName"
                    placeholder="Nome do usuário"
                  />
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Email do Responsável</mat-label>
                  <input
                    type="email"
                    matInput
                    formControlName="uploaderEmail"
                    placeholder="email@exemplo.com"
                  />
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Data Inicial</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerStart"
                    formControlName="startDate"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                  <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>
              </div>

              <div class="col-md-3">
                <mat-form-field class="w-100" appearance="fill">
                  <mat-label>Data Final</mat-label>
                  <input
                    matInput
                    [matDatepicker]="pickerEnd"
                    formControlName="endDate"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                  <mat-datepicker #pickerEnd></mat-datepicker>
                </mat-form-field>
              </div>
            </div>
          </form>

          <!-- Botões de ação -->
          <div class="row mb-4">
            <div class="col-12 d-flex justify-content-between align-items-center">
              <button
                type="button"
                class="btn btn-secondary"
                (click)="limparFiltros()"
              >
                <i class="fas fa-eraser mr-1"></i> Limpar Filtros
              </button>

              <button
                type="button"
                class="btn btn-success"
                (click)="exportarParaExcel()"
                [disabled]="loading"
              >
                <i class="fas fa-file-excel mr-1"></i> Exportar para Excel
              </button>
            </div>
          </div>

          <!-- Loading spinner -->
          <div *ngIf="loading" class="text-center my-5">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Carregando...</span>
            </div>
          </div>

          <!-- Tabela de arquivos -->
          <div class="table-responsive" [style.display]="loading ? 'none' : 'block'">
            <table
              mat-table
              [dataSource]="dataSource"
              matSort
              class="table table-hover"
            >
              <!-- Coluna Nome do Arquivo -->
              <ng-container matColumnDef="originalFileName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Nome do Arquivo
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  <i class="fas fa-file-alt mr-2 text-muted"></i>
                  {{ arquivo.originalFileName }}
                </td>
              </ng-container>

              <!-- Coluna Nome do Insumo -->
              <ng-container matColumnDef="insumoName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Insumo
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ arquivo.insumoName }}
                </td>
              </ng-container>

              <!-- Coluna Segmento -->
              <ng-container matColumnDef="insumoSegment">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Segmento
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ arquivo.insumoSegment }}
                </td>
              </ng-container>

              <!-- Coluna Competência -->
              <ng-container matColumnDef="insumoCompetence">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Competência
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ arquivo.insumoCompetence }}
                </td>
              </ng-container>

              <!-- Coluna Status -->
              <ng-container matColumnDef="competenceStatus">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Status
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  <span
                    class="badge"
                    [ngClass]="getStatusClass(arquivo.competenceStatus)"
                  >
                    {{ getStatusLabel(arquivo.competenceStatus) }}
                  </span>
                </td>
              </ng-container>

              <!-- Coluna Responsável -->
              <ng-container matColumnDef="userUploadFullName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Responsável
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ arquivo.userUploadFullName }}
                </td>
              </ng-container>

              <!-- Coluna Email -->
              <ng-container matColumnDef="userUploadEmail">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Email
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ arquivo.userUploadEmail }}
                </td>
              </ng-container>

              <!-- Coluna Data de Upload -->
              <ng-container matColumnDef="createdAt">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Data de Upload
                </th>
                <td mat-cell *matCellDef="let arquivo">
                  {{ formatarData(arquivo.createdAt) }}
                </td>
              </ng-container>

              <!-- Coluna Versão -->
              <ng-container matColumnDef="version">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  Versão
                </th>
                <td mat-cell *matCellDef="let arquivo" class="text-center">
                  <span class="badge badge-info">v{{ arquivo.version }}</span>
                </td>
              </ng-container>

              <!-- Coluna Ações -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center">
                  Ações
                </th>
                <td mat-cell *matCellDef="let arquivo" class="text-center">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="downloadArquivo(arquivo)"
                    title="Download"
                  >
                    <mat-icon>download</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    color="accent"
                    (click)="visualizarInsumo(arquivo.insumoId)"
                    title="Ver Insumo"
                  >
                    <mat-icon>visibility</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>

          <!-- Mensagem quando não há dados -->
          <div
            *ngIf="!loading && (!dataSource || dataSource.length === 0)"
            class="alert alert-info text-center mt-4"
          >
            <i class="fas fa-info-circle mr-2"></i>
            Nenhum arquivo encontrado com os filtros selecionados.
          </div>

          <!-- Paginação -->
          <mat-paginator
            [style.display]="loading || !dataSource || dataSource.length === 0 ? 'none' : 'block'"
            [length]="dataSourceLength"
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            showFirstLastButtons
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
